import React from 'react';

interface IRentReportCancelIcon {
  color?: string;
  onClick?: any;
}
const RentReportCancelIcon = ({
  color,
  onClick,
}: IRentReportCancelIcon) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    onClick={onClick}
    style={{ cursor: 'pointer' }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.0001 13.3996C10.5347 13.3996 13.4001 10.5342 13.4001 6.99961C13.4001 3.46499 10.5347 0.599609 7.0001 0.599609C3.46548 0.599609 0.600098 3.46499 0.600098 6.99961C0.600098 10.5342 3.46548 13.3996 7.0001 13.3996ZM5.96578 4.83392C5.65336 4.5215 5.14683 4.5215 4.83441 4.83392C4.52199 5.14634 4.52199 5.65288 4.83441 5.96529L5.86873 6.99961L4.83441 8.03392C4.52199 8.34634 4.52199 8.85287 4.83441 9.16529C5.14683 9.47771 5.65336 9.47771 5.96578 9.16529L7.0001 8.13098L8.03441 9.16529C8.34683 9.47771 8.85336 9.47771 9.16578 9.16529C9.4782 8.85288 9.4782 8.34634 9.16578 8.03392L8.13147 6.99961L9.16578 5.96529C9.4782 5.65288 9.4782 5.14634 9.16578 4.83392C8.85336 4.5215 8.34683 4.5215 8.03441 4.83392L7.0001 5.86824L5.96578 4.83392Z"
      fill={color || '#F04248'}
    />
  </svg>
);
export default RentReportCancelIcon;
